import { render, staticRenderFns } from "./LicensingCatalog.vue?vue&type=template&id=7d8b2b5c&scoped=true&"
import script from "./LicensingCatalog.vue?vue&type=script&lang=js&"
export * from "./LicensingCatalog.vue?vue&type=script&lang=js&"
import style0 from "./LicensingCatalog.vue?vue&type=style&index=0&id=7d8b2b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b2b5c",
  null
  
)

export default component.exports